var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "el-row",
          {
            staticClass: "btn",
            attrs: { type: "flex", justify: "start", align: "middle" },
          },
          [
            !_vm.isDisabled &&
            _vm.basicForm.latestInspectId == _vm.basicForm.inspectId &&
            _vm.isEdit
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.NUTRITION_INSPECT_SUBMIT,
                        expression: "NUTRITION_INSPECT_SUBMIT",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      disabled: _vm.isSaDisabled,
                      loading: _vm.isSaLoading,
                    },
                    on: { click: _vm.onSaveClick },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            !_vm.isDisabled &&
            _vm.basicForm.latestInspectId == _vm.basicForm.inspectId &&
            _vm.isSubmit
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.NUTRITION_INSPECT_SUBMIT,
                        expression: "NUTRITION_INSPECT_SUBMIT",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      disabled: _vm.isSubDisabled,
                      loading: _vm.isSubLoading,
                    },
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v("提交")]
                )
              : _vm._e(),
            !_vm.isDisabled &&
            _vm.basicForm.latestInspectId != _vm.basicForm.inspectId &&
            _vm.isSubmit
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.NUTRITION_INSPECT_SUBMIT,
                        expression: "NUTRITION_INSPECT_SUBMIT",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.onEdit },
                  },
                  [_vm._v("编辑最新数据")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("el-row", [
              _c("div", { staticClass: "info_box_title" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "info_title" }, [_vm._v("基本信息")]),
              ]),
            ]),
            _c(
              "el-form",
              {
                ref: "basicForm",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.basicForm,
                  rules: _vm.rules,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "检测窗口期", prop: "windowTime" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.windowTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "windowTime", $$v)
                                },
                                expression: "basicForm.windowTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "版本", prop: "versionText" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.versionText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "versionText", $$v)
                                },
                                expression: "basicForm.versionText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "产品编码", prop: "fiveBitCode" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.fiveBitCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "fiveBitCode", $$v)
                                },
                                expression: "basicForm.fiveBitCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "产品中文名称", prop: "describe" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.describe,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "describe", $$v)
                                },
                                expression: "basicForm.describe",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "产品英文名称",
                              prop: "fiveBitCodeName",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.fiveBitCodeName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.basicForm,
                                    "fiveBitCodeName",
                                    $$v
                                  )
                                },
                                expression: "basicForm.fiveBitCodeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "结算单位名称",
                              prop: "supplierName",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.supplierName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "supplierName", $$v)
                                },
                                expression: "basicForm.supplierName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "工厂名称", prop: "facilityName" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.facilityName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "facilityName", $$v)
                                },
                                expression: "basicForm.facilityName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category2",
                              prop: "categoryLevel2Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.basicForm.categoryLevel2Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicForm,
                                      "categoryLevel2Code",
                                      $$v
                                    )
                                  },
                                  expression: "basicForm.categoryLevel2Code",
                                },
                              },
                              _vm._l(_vm.categoryList2, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "categoryLevel3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.basicForm.categoryLevel3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicForm,
                                      "categoryLevel3Code",
                                      $$v
                                    )
                                  },
                                  expression: "basicForm.categoryLevel3Code",
                                },
                              },
                              _vm._l(_vm.categoryList3, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "检测实验室", prop: "labCodeText" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.labCodeText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "labCodeText", $$v)
                                },
                                expression: "basicForm.labCodeText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "烹饪方式", prop: "cookCodeText" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.cookCodeText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "cookCodeText", $$v)
                                },
                                expression: "basicForm.cookCodeText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "COA NO.", prop: "coaNo" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.basicForm.coaNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "coaNo", $$v)
                                },
                                expression: "basicForm.coaNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "提交日期", prop: "cqsSubmitDate" },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                disabled: "",
                              },
                              model: {
                                value: _vm.basicForm.cqsSubmitDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "cqsSubmitDate", $$v)
                                },
                                expression: "basicForm.cqsSubmitDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "检测日期", prop: "labSubmitDate" },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                disabled: "",
                              },
                              model: {
                                value: _vm.basicForm.labSubmitDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "labSubmitDate", $$v)
                                },
                                expression: "basicForm.labSubmitDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "更新人", prop: "updateByName" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.updateByName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "updateByName", $$v)
                                },
                                expression: "basicForm.updateByName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "更新日期", prop: "updateDate" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                disabled: "",
                              },
                              model: {
                                value: _vm.basicForm.updateDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "updateDate", $$v)
                                },
                                expression: "basicForm.updateDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "状态", prop: "inspectStatusText" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.inspectStatusText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.basicForm,
                                    "inspectStatusText",
                                    $$v
                                  )
                                },
                                expression: "basicForm.inspectStatusText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("el-row", [
              _c("div", { staticClass: "info_box_title" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "info_title" }, [
                  _vm._v("Nutrition明细"),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.isDisabled &&
                      _vm.basicForm.latestInspectId === _vm.basicForm.inspectId,
                    expression:
                      "!isDisabled&&(basicForm.latestInspectId===basicForm.inspectId)",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  { ref: "detailForm", attrs: { model: _vm.detailForm } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "myTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.detailForm.currentDetailList,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                      },
                      _vm._l(
                        _vm.detailForm.tableHeaderList,
                        function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: item.prop,
                              label: item.label,
                              "min-width": "150",
                              "render-header": (h, obj) =>
                                _vm.renderHeader(h, obj, item),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              `currentDetailList.${scope.$index}.` +
                                              `${item.prop}`,
                                            rules: item.required
                                              ? [
                                                  {
                                                    required: true,
                                                    message: "请输入*",
                                                    trigger: ["blur", "change"],
                                                  },
                                                ]
                                              : "",
                                          },
                                        },
                                        [
                                          item.prop == "windowTime" ||
                                          item.prop == "version"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[item.prop])
                                                ),
                                              ])
                                            : _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.propInput(
                                                      scope.row,
                                                      item.prop,
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row[item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row[item.prop]",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isDisabled ||
                      _vm.basicForm.latestInspectId !== _vm.basicForm.inspectId,
                    expression:
                      "isDisabled||(basicForm.latestInspectId!==basicForm.inspectId)",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  { attrs: { model: _vm.detailForm } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "myTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.detailForm.currentDetailList,
                          "cell-class-name": _vm.cellClassName,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                      },
                      _vm._l(
                        _vm.detailForm.tableHeaderList,
                        function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: item.prop,
                              label: item.label,
                              "min-width": "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row[item.prop] &&
                                      scope.row[item.prop + "_gapReason"]
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  scope.row[
                                                    item.prop + "_gapReason"
                                                  ],
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "nutrition_p" },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[item.prop])
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "nutrition_p" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[item.prop])
                                                ),
                                              ]),
                                            ]
                                          ),
                                      scope.row[item.prop + "_alertFlag"] ==
                                        "Y" &&
                                      scope.row[
                                        item.prop + "_gapPercentPreWindow"
                                      ]
                                        ? _c(
                                            "p",
                                            { staticClass: "nutrition_p_span" },
                                            [
                                              _c("i", {
                                                class:
                                                  Number(
                                                    scope.row[
                                                      item.prop +
                                                        "_gapPercentPreWindow"
                                                    ]
                                                  ) > 0
                                                    ? "el-icon-top"
                                                    : "el-icon-bottom",
                                              }),
                                              Number(
                                                scope.row[
                                                  item.prop +
                                                    "_gapPercentPreWindow"
                                                ]
                                              ) > 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[
                                                          item.prop +
                                                            "_gapPercentPreWindow"
                                                        ] + "%"
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              Number(
                                                scope.row[
                                                  item.prop +
                                                    "_gapPercentPreWindow"
                                                ]
                                              ) < 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        Math.abs(
                                                          scope.row[
                                                            item.prop +
                                                              "_gapPercentPreWindow"
                                                          ]
                                                        ) + "%"
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("el-row", [
              _c("div", { staticClass: "info_box_title" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "info_title" }, [
                  _vm._v("Nutrition历史参考明细"),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              [
                _c(
                  "el-table",
                  {
                    ref: "refTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.historyWindowDetailList,
                      "cell-class-name": _vm.cellClassName,
                      "max-height": "425",
                      border: "",
                      stripe: "",
                    },
                  },
                  _vm._l(
                    _vm.detailForm.tableHeaderList,
                    function (item, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: item.prop,
                          label: item.label,
                          "min-width": "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row[item.prop] &&
                                  scope.row[item.prop + "_gapReason"]
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              scope.row[
                                                item.prop + "_gapReason"
                                              ],
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "nutrition_p" },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[item.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        { staticClass: "nutrition_p" },
                                        [
                                          item.prop == "windowTime"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToDetail(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[item.prop])
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[item.prop])
                                                ),
                                              ]),
                                        ],
                                        1
                                      ),
                                  scope.row[item.prop + "_alertFlag"] == "Y" &&
                                  scope.row[item.prop + "_gapPercentPreWindow"]
                                    ? _c(
                                        "p",
                                        { staticClass: "nutrition_p_span" },
                                        [
                                          _c("i", {
                                            class:
                                              Number(
                                                scope.row[
                                                  item.prop +
                                                    "_gapPercentPreWindow"
                                                ]
                                              ) > 0
                                                ? "el-icon-top"
                                                : "el-icon-bottom",
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                Math.abs(
                                                  scope.row[
                                                    item.prop +
                                                      "_gapPercentPreWindow"
                                                  ]
                                                ) + "%"
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }
                  ),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-tabs",
                  { attrs: { type: "border-card" } },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "附件上传" } },
                      [
                        _c(
                          "el-row",
                          { staticClass: "action-btn-row" },
                          [
                            !_vm.isDisabled &&
                            _vm.basicForm.latestInspectId ==
                              _vm.basicForm.inspectId
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { size: "mini", type: "primary" },
                                    on: { click: _vm.onUploadFile },
                                  },
                                  [_vm._v("上传")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-table",
                          {
                            ref: "fileTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.fileTableData,
                              "max-height": "326px",
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "序号",
                                type: "index",
                                "min-width": "50px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "附件类型",
                                prop: "attachmentTypeText",
                                "show-overflow-tooltip": "",
                                "min-width": "100px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "附件名称",
                                prop: "documentName",
                                "show-overflow-tooltip": "",
                                "min-width": "180px",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.tmDocumentId
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDownload(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.documentName)
                                              ),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.documentName)
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "上传人",
                                prop: "uploadBy",
                                "show-overflow-tooltip": "",
                                "min-width": "100px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "上传时间",
                                prop: "uploadTime",
                                "show-overflow-tooltip": "",
                                "min-width": "100px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", "min-width": "120px" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      !_vm.isDisabled &&
                                      _vm.basicForm.latestInspectId ==
                                        _vm.basicForm.inspectId &&
                                      scope.row.canOperation
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                padding: "1px!important",
                                              },
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteFile(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "变更信息" } },
                      [
                        _c(
                          "el-row",
                          _vm._l(_vm.changeVersionList, function (item, index) {
                            return _c(
                              "el-col",
                              { key: index },
                              [
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "searchForm",
                                    attrs: {
                                      "label-position": "right",
                                      "label-width": "120px",
                                    },
                                  },
                                  [
                                    _c("el-row", [
                                      _c(
                                        "div",
                                        { staticClass: "info_box_title" },
                                        [
                                          _c("p", { staticClass: "line" }),
                                          _c(
                                            "p",
                                            { staticClass: "info_title" },
                                            [
                                              _vm._v(
                                                "修订版本 " +
                                                  _vm._s(item[0].version)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 20 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "变更日期",
                                                  prop: "updateDate",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    format:
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value: item[0].updateDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item[0],
                                                        "updateDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item[0].updateDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "变更人",
                                                  prop: "updateByName",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value: item[0].updateByName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item[0],
                                                        "updateByName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item[0].updateByName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "修改备注",
                                                  prop: "updateReason",
                                                },
                                              },
                                              [
                                                item[0].updateReason &&
                                                item[0].updateReason.length > 50
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item[0]
                                                              .updateReason,
                                                          placement:
                                                            "top-start",
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            rows: 1,
                                                            type: "textarea",
                                                            maxlength: "100",
                                                            "show-word-limit":
                                                              "",
                                                            disabled: "",
                                                          },
                                                          model: {
                                                            value:
                                                              item[0]
                                                                .updateReason,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item[0],
                                                                "updateReason",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item[0].updateReason",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c("el-input", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        rows: 1,
                                                        type: "textarea",
                                                        maxlength: "100",
                                                        "show-word-limit": "",
                                                        disabled: "",
                                                      },
                                                      model: {
                                                        value:
                                                          item[0].updateReason,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item[0],
                                                            "updateReason",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item[0].updateReason",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: item,
                                      "max-height": "425",
                                      "cell-class-name": _vm.cellClassName1,
                                      border: "",
                                      stripe: "",
                                    },
                                  },
                                  _vm._l(
                                    _vm.detailForm.tableHeaderList,
                                    function (item, index) {
                                      return _c("el-table-column", {
                                        key: index,
                                        attrs: {
                                          prop: item.prop,
                                          label: item.label,
                                          "min-width": "150",
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _c("el-divider"),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "操作日志" } },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.operationLogList,
                              "max-height": "425",
                              border: "",
                              stripe: "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "createDate",
                                label: "操作时间",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "creater",
                                label: "操作人",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "describe",
                                label: "操作描述",
                                "min-width": "300",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "附件上传",
              visible: _vm.dialogUploadFileVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogUploadFileVisible = $event
              },
              close: _vm.onCloseUploadFile,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "fileForm",
                attrs: {
                  model: _vm.fileForm,
                  rules: _vm.filesRules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "seq", label: "附件类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.fileForm.seq,
                          callback: function ($$v) {
                            _vm.$set(_vm.fileForm, "seq", $$v)
                          },
                          expression: "fileForm.seq",
                        },
                      },
                      _vm._l(_vm.typeLists, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.code,
                            attrs: {
                              label: item.chineseValue,
                              value: item.code,
                            },
                          },
                          [
                            item.code == "INSPECT_ATTACHMENT_TYPE_002" ||
                            item.code == "INSPECT_ATTACHMENT_TYPE_001"
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                            _c("span", [_vm._v(_vm._s(item.chineseValue))]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "files", label: "选择文件" } },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "upload",
                        attrs: {
                          name: "file",
                          action: "",
                          "http-request": _vm.httpRequest,
                          "before-upload": _vm.beforeUpload,
                          "show-file-list": false,
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.fileForm.files,
                              callback: function ($$v) {
                                _vm.$set(_vm.fileForm, "files", $$v)
                              },
                              expression: "fileForm.files",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: { slot: "append", icon: "el-icon-search" },
                              slot: "append",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.uploadClick },
                  },
                  [_vm._v("上传")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onCloseUploadFile },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "修改备注",
              visible: _vm.dialogVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.onClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "updateForm",
                attrs: { model: _vm.updateForm, "label-width": "100px" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "修改备注",
                      prop: "updateReason",
                      rules: {
                        required: true,
                        message: "修改备注不能为空",
                        trigger: "blur",
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 4,
                        maxlength: "1000",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.updateForm.updateReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateForm, "updateReason", $$v)
                        },
                        expression: "updateForm.updateReason",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isCDisabled,
                      loading: _vm.isCLoading,
                    },
                    on: { click: _vm.onSave },
                  },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }